export default {"src":"/_next/static/media/icon_list.3786c7c9.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};